import { Grid, InnerSection, InvestorProfileChip, Modal, Typography } from "src/lib"
import { IRecommendationDetailsModalProps } from "./types"
import { mapPerfilToProfile } from "src/lib/transformers/ClientsOverviewInfo"
import intl from "src/internationalization/intl"
import { useDrawerStore, useMessageStore } from "src/store"

const RecommendationDetailsModal = ({ recommendation, client, open, ...props }: IRecommendationDetailsModalProps) => {
    const setJsonContext = useMessageStore((s: any) => s.setJsonContext)
    const setActualContext = useMessageStore((s: any) => s.setActualContext)
    const openDrawer = useDrawerStore((s: any) => s.openDrawer)

    const contextLabel = intl('investmentDetails')

    const handleClickAIButton = () => {
        setJsonContext(recommendation)
        setActualContext(contextLabel)
        openDrawer()
    }

    if (!recommendation) {
        return null
    }

    return (
        <Modal
            {...props}
            onClickAIButton={handleClickAIButton}
            open={open}
            title={intl('investmentDetails')}
        >
            <Grid item xs={12}>
                <InnerSection title={intl('product')}>
                    <Typography variant="body1">
                        {recommendation.product || '-'}
                    </Typography>
                </InnerSection>
            </Grid>
            <Grid container gap={2} sx={{mt: 2}}>
                <InnerSection title="Vol(12M)">
                    <Typography variant="body1">
                        {recommendation.product_aa !== null && recommendation.product_aa !== undefined
                            ? recommendation.product_aa.toFixed(2)
                            : '-'}
                    </Typography>
                </InnerSection>
                <InnerSection title={intl('liquidity')}>
                    <Typography variant="body1">
                        {recommendation.liquidity || '-'}
                    </Typography>
                </InnerSection>
                <InnerSection title={intl('category')}>
                    <Typography variant="body1">
                        {recommendation.category || '-'}
                    </Typography>
                </InnerSection>
                <InnerSection title={intl('type') || 'Tipo'}>
                    <Typography variant="body1">
                        {recommendation.type || '-'}
                    </Typography>
                </InnerSection>
            </Grid>
            <Grid container gap={2} sx={{mt: 2}}>
                <InnerSection title={intl('comission')}>
                    <Typography variant="body1" color="success">
                        {recommendation.administration_fee || '-'}
                    </Typography>
                </InnerSection>
                <InnerSection title={intl('suitability')}>
                    <Grid sx={{mt: 1}}>
                        {/* TODO: pegar o perfil do investimento */}
                        <InvestorProfileChip profile={mapPerfilToProfile("SOFISTICADO")} />
                    </Grid>
                    <Typography variant="caption">{`${intl('reference')}: BTG`}</Typography>
                </InnerSection>
            </Grid>
            <Grid sx={{mt: 2}}>
                <InnerSection title={intl('effectiveReturn')}>
                    <Grid container gap={2}>
                        {recommendation.effective_return_to_month && <InnerSection title={intl('month')}>
                            <Typography variant="body1">{recommendation.effective_return_to_month || '-'}</Typography>
                        </InnerSection>}
                        {recommendation.effective_return_to_12_months && <InnerSection title={intl('year')}>
                            <Typography variant="body1">{recommendation.effective_return_to_12_months || '-'}</Typography>
                        </InnerSection>} 
                        {recommendation.effective_return_to_24_months && <InnerSection title={intl('m24')}>
                            <Typography variant="body1">{recommendation.effective_return_to_24_months || '-'}</Typography>
                        </InnerSection>}
                        {recommendation.effective_return_to_36_months && <InnerSection title={intl('m36')}>
                            <Typography variant="body1">{recommendation.effective_return_to_36_months || '-'}</Typography>
                        </InnerSection>}
                    </Grid>
                </InnerSection>
            </Grid>
            <Grid container gap={2} sx={{mt: 2}}>
                <InnerSection title={intl('cnpj')}>
                    <Typography variant="body1">{recommendation.cnpj || '-'}</Typography>
                </InnerSection>
                <InnerSection title={intl('assetManager')}>
                    <Typography variant="body1">-</Typography>
                </InnerSection>
                <InnerSection title={intl('public')}>
                    <Typography variant="body1">{recommendation.public || '-'}</Typography>
                </InnerSection>
                <InnerSection title={intl('minimalApplication')}>
                    <Typography variant="body1">{recommendation.minimal_application || '-'}</Typography>
                </InnerSection>
            </Grid>
            {/* TODO: adicionar o restante das informações */}
            <Grid container gap={2} sx={{mt: 2}}>
                <InnerSection title={intl('globalRate')}>
                    <Typography variant="body1">-</Typography>
                </InnerSection>
                <InnerSection title={intl('referenceRate')}>
                    <Typography variant="body1">-</Typography>
                </InnerSection>
                <InnerSection title={intl('benchmark')}>
                    <Typography variant="body1">{recommendation.benchmark || '-'}</Typography>
                </InnerSection>
            </Grid>
        </Modal>
    )
}

export { RecommendationDetailsModal }

